<template>
  <svg
    :width="size"
    :height="size"
    :viewBox="`0 0 ${size} ${size}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.6562 5.6875C15.9832 5.6875 15.4375 5.14185 15.4375 4.46875C15.4375 3.79565 15.9832 3.25 16.6562 3.25H21.1265C22.0231 3.25 22.75 3.97687 22.75 4.8735V9.34375C22.75 10.0168 22.2043 10.5625 21.5312 10.5625C20.8582 10.5625 20.3125 10.0168 20.3125 9.34375V7.41107L15.9423 11.7812C15.4664 12.2572 14.6947 12.2572 14.2188 11.7812C13.7428 11.3053 13.7428 10.5336 14.2188 10.0577L18.5889 5.6875H16.6562ZM9.34375 20.3125H7.41107L11.7812 15.9423C12.2572 15.4664 12.2572 14.6947 11.7812 14.2188C11.3053 13.7428 10.5336 13.7428 10.0577 14.2188L5.6875 18.5889V16.6562C5.6875 15.9832 5.14185 15.4375 4.46875 15.4375C3.79565 15.4375 3.25 15.9832 3.25 16.6562V21.125C3.25 22.0225 3.97754 22.75 4.875 22.75H9.34375C10.0168 22.75 10.5625 22.2043 10.5625 21.5312C10.5625 20.8582 10.0168 20.3125 9.34375 20.3125Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "i-fullscreen",
  props: {
    size: {
      type: String | Number,
      default: "26"
    },
    color: {
      type: String,
      default: "white"
    }
  }
};
</script>

<style scoped lang="less">
svg {
  transition: all 0.5s;
  path {
    transition: all 0.5s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/icons/play_control/fullscreen.vue